// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Ysli","paramInput":"JobSimulator_paramInput__2vLTK","input":"JobSimulator_input__32Swm"};